import { createFileRoute, Link, useSearch } from '@tanstack/react-router';
import { AlertCircle } from 'lucide-react';

export const Route = createFileRoute('/auth/error')({
  validateSearch: (search: Record<string, unknown>) => ({
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  component: AuthError,
});

function AuthError() {
  const { error } = useSearch({ from: '/auth/error' });

  return (
    <div className="flex items-center justify-center h-dvh px-4">
      <div className="flex flex-col items-center gap-5 max-w-sm text-center">
        <div className="rounded-full bg-destructive/10 p-3">
          <AlertCircle className="h-6 w-6 text-destructive" />
        </div>
        <div className="space-y-2">
          <h1 className="text-lg font-semibold text-foreground">
            Authentication error
          </h1>
          <p className="text-sm text-muted-foreground">
            Something went wrong during sign-in. Please try again.
          </p>
        </div>
        {error && (
          <p className="text-xs text-muted-foreground/60 font-mono">{error}</p>
        )}
        <Link
          to="/page/$id"
          params={{ id: '1' }}
          className="inline-flex items-center justify-center rounded-xl bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Back to reader
        </Link>
      </div>
    </div>
  );
}
